<template>
 


 <div v-if='loadedd'>

 
<div    v-if='scrbox' style="position: fixed;top: 0;left: 0;right: 0;bottom: 0;z-index: -1;opacity: 0;cursor: pointer;" class="d-flex align-items-center justify-content-center">
  <div style="position:absolute;top: 0;left: 0;right: 0;bottom: 0;background: rgba(0,0,0,0.1);cursor: pointer;"></div>


 
  
  <div style="width:100%;text-align:center;position:relative;z-index: 1;">
 
 <img :src="imagess" style="max-width: 100%;opacity: 0;" id="imgetst"   />
 
</div>
</div>

<div v-if='delbox' style="position: fixed;top: 0;left: 0;right: 0;bottom: 0;z-index: 10000000;" class="d-flex align-items-center justify-content-center">
  <div v-on:click='delbox=false' style="position:absolute;top: 0;left: 0;right: 0;bottom: 0;background: rgba(0,0,0,0.1);"></div>
  <div style="width: 450px; padding: 30px;border-radius: 10px;background:#fff;position: relative;z-index: 1000;">
    <div>
      

      <div class="d-flex align-items-center">
        <div style="width:40px;height:40px;border-radius:5px;background:rgba(224, 71, 95, 0.2)" class="d-flex align-items-center justify-content-center">
          <i class='bx bxs-trash-alt' style="font-size:20px;color:rgb(224, 71, 95)" ></i>
        </div>
        <h2 style="margin-bottom:0px;margin-left:20px;color: rgb(32, 34, 43);font-weight:400;font-size: 18px">Delete this video?</h2>
      </div>
<p style="font-weight:300;font-size: 15px;color: rgb(43, 47, 59);" class="mt-3">Are you sure you want to delete this video?</p>
      <div class="d-flex align-items-end justify-content-end  mt-4">
                <div v-on:click='delbox=false' style="background:#fff;padding:6px 13px;border-radius:5px;color: rgb(102, 106, 114);font-weight: 500;font-size:14px;border:1px solid #999;margin-right: 20px;cursor: pointer;">Cancel</div>

        <div style="background:rgb(212, 67, 90);padding:6px 13px;border-radius:5px;color: #fff;font-weight: 500;font-size:14px;cursor: pointer;" v-on:click='deletevideo'>Delete</div>
      </div>
 
    </div>  
  </div>

</div>





<div v-if='deletebox' style="position: fixed;top: 0;left: 0;right: 0;bottom: 0;z-index: 10000000;" class="d-flex align-items-center justify-content-center">
  <div v-on:click='addboxproject=false' style="position:absolute;top: 0;left: 0;right: 0;bottom: 0;background: rgba(0,0,0,0.1);"></div>
  <div style="width: 450px; padding: 30px;border-radius: 10px;background:#fff;position: relative;z-index: 1000;">
    <div>
      

      <div class="d-flex align-items-center">
        <div style="width:40px;height:40px;border-radius:5px;background:rgba(224, 71, 95, 0.2)" class="d-flex align-items-center justify-content-center">
          <i class='bx bxs-trash-alt' style="font-size:20px;color:rgb(224, 71, 95)" ></i>
        </div>
        <h2 style="margin-bottom:0px;margin-left:20px;color: rgb(32, 34, 43);font-weight:400;font-size: 18px">Delete this comment?</h2>
      </div>
<p style="font-weight:300;font-size: 15px;color: rgb(43, 47, 59);" class="mt-3">Are you sure you want to delete this comment?</p>
      <div class="d-flex align-items-end justify-content-end  mt-4">
                <div v-on:click='deletebox=false' style="background:#fff;padding:6px 13px;border-radius:5px;color: rgb(102, 106, 114);font-weight: 500;font-size:14px;border:1px solid #999;margin-right: 20px;cursor: pointer;">Cancel</div>

        <div style="background:rgb(212, 67, 90);padding:6px 13px;border-radius:5px;color: #fff;font-weight: 500;font-size:14px;cursor: pointer;" v-on:click='deletes'>Delete</div>
      </div>
 
    </div>  
  </div>

</div>






<div v-if='deleteboxreply' style="position: fixed;top: 0;left: 0;right: 0;bottom: 0;z-index: 10000000;" class="d-flex align-items-center justify-content-center">
  <div v-on:click='addboxproject=false' style="position:absolute;top: 0;left: 0;right: 0;bottom: 0;background: rgba(0,0,0,0.1);"></div>
  <div style="width: 450px; padding: 30px;border-radius: 10px;background:#fff;position: relative;z-index: 1000;">
    <div>
      

      <div class="d-flex align-items-center">
        <div style="width:40px;height:40px;border-radius:5px;background:rgba(224, 71, 95, 0.2)" class="d-flex align-items-center justify-content-center">
          <i class='bx bxs-trash-alt' style="font-size:20px;color:rgb(224, 71, 95)" ></i>
        </div>
        <h2 style="margin-bottom:0px;margin-left:20px;color: rgb(32, 34, 43);font-weight:400;font-size: 18px">Delete this comment?</h2>
      </div>
<p style="font-weight:300;font-size: 15px;color: rgb(43, 47, 59);" class="mt-3">Are you sure you want to delete this comment?</p>
      <div class="d-flex align-items-end justify-content-end  mt-4">
                <div v-on:click='deleteboxreply=false' style="background:#fff;padding:6px 13px;border-radius:5px;color: rgb(102, 106, 114);font-weight: 500;font-size:14px;border:1px solid #999;margin-right: 20px;cursor: pointer;">Cancel</div>

        <div style="background:rgb(212, 67, 90);padding:6px 13px;border-radius:5px;color: #fff;font-weight: 500;font-size:14px;cursor: pointer;" v-on:click='deletesreply'>Delete</div>
      </div>
 
    </div>  
  </div>

</div>







  <div  style="position:fixed;top: 0;left: 0;right: 0;z-index: 100000000000;background:#20222B" >
    <div class="container-fluid">
      <div class="cuswidth2" style="padding:0px">
        <div class="d-flex align-items-center justify-content-between py-2">
          <div class="d-flex align-items-center">
            <i class='bx bx-chevron-left' style="color:#12B789;font-size:35px;margin-right:10px;cursor: pointer;transform: translateY(2px);" v-on:click='$router.go(-1)' ></i>
            <p style="color:#F9F9F9;margin-bottom:0px;font-weight:400;;font-size:14px">{{alldata.name}}</p>
          </div>

          <div class="d-flex align-items-center">
            <div  style="padding:6px ;border-radius:5px;background:#323744;cursor:pointer;position:relative" >


<div v-if='statusbox' style="position:fixed;top: 0;left: 0;right: 0;bottom: 0;cursor: pointer;z-index: 100;" v-on:click='statusbox=false'></div>
              <div v-if='statusbox' style="position:absolute;top:50px;width:200px;left:50%;transform:translateX(-50%);background:#fff;border-radius:6px;z-index:10000000;padding:8px 15px;box-shadow:0 0 10px rgba(0,0,0,0.1)">
                <div class="d-flex align-items-center py-1" v-on:click='setstatus(0)' >
                <div style="width:10px;height:10px;border-radius:50%;border:1px solid #636882;"></div>
                <p  class="statuslist" :style="{'fontWeight':status==0?'600':'400'}">No Status 
                  <i  v-if="status==0" class='bx bx-check' style="color:#12B789;font-size:17px;margin-left:2px;vertical-align:middle;display:inline-block;transform:translateY(-2px)" ></i>

                </p>
              </div>
              <div class="d-flex align-items-center py-1"  v-on:click='setstatus(1)'>
                <div style="width:10px;height:10px;border-radius:50%;border:1px solid #ff9659;"></div>
                <p  class="statuslist" :style="{'fontWeight':status==1?'600':'400'}">Needs Review 
                  <i  v-if="status==1" class='bx bx-check' style="color:#12B789;font-size:17px;margin-left:2px;vertical-align:middle;display:inline-block;transform:translateY(-2px)" ></i>

                </p>
              </div>
              <div class="d-flex align-items-center py-1" v-on:click='setstatus(2)' >
                <div style="width:10px;height:10px;border-radius:50%;border:1px solid #61caff;"></div>
                <p class="statuslist" :style="{'fontWeight':status==2?'600':'400'}" >In Progress 
                  <i  v-if="status==2" class='bx bx-check' style="color:#12B789;font-size:17px;margin-left:2px;vertical-align:middle;display:inline-block;transform:translateY(-2px)" ></i>

                </p>
              </div>
              <div class="d-flex align-items-center py-1" v-on:click='setstatus(3)' >
                <div style="width:10px;height:10px;border-radius:50%;border:1px solid #1dc0a6;"></div>
                <p class="statuslist" :style="{'fontWeight':status==3?'600':'400'}">Approved 
                  <i v-if="status==3"  class='bx bx-check' style="color:#12B789;font-size:17px;margin-left:2px;vertical-align:middle;display:inline-block;transform:translateY(-2px)" ></i>

                </p>
              </div>

              </div>


















              <div class="d-flex align-items-center" v-if="status==0" v-on:click='statusbox=true'>
                <div style="width:8px;height:8px;border-radius:50%;border:1px solid #636882;"></div>
                <p style="margin-bottom:0px;font-weight:400;color:#fff;font-size:12px;margin-left:10px">No Status <i class='bx bx-chevron-down' style="color:#fff;font-size:17px;margin-left:2px;vertical-align:middle;display:inline-block;transform:translateY(-2px)" ></i></p>
              </div>
              <div class="d-flex align-items-center" v-if="status==1" v-on:click='statusbox=true'>
                <div style="width:8px;height:8px;border-radius:50%;border:1px solid #ff9659;background:#ff9659"></div>
                <p style="margin-bottom:0px;font-weight:400;color:#fff;font-size:12px;margin-left:10px">Needs Review <i class='bx bx-chevron-down' style="color:#fff;font-size:17px;margin-left:2px;vertical-align:middle;display:inline-block;transform:translateY(-2px)" ></i></p>
              </div>
              <div class="d-flex align-items-center" v-if="status==2" v-on:click='statusbox=true'>
                <div style="width:8px;height:8px;border-radius:50%;border:1px solid #61caff;background:#61caff"></div>
                <p style="margin-bottom:0px;font-weight:400;color:#fff;font-size:12px;margin-left:10px">In Progress <i class='bx bx-chevron-down' style="color:#fff;font-size:17px;margin-left:2px;vertical-align:middle;display:inline-block;transform:translateY(-2px)" ></i></p>
              </div>
              <div class="d-flex align-items-center" v-if="status==3" v-on:click='statusbox=true'>
                <div style="width:8px;height:8px;border-radius:50%;border:1px solid #1dc0a6;background:#1dc0a6"></div>
                <p style="margin-bottom:0px;font-weight:400;color:#fff;font-size:12px;margin-left:10px">Approved <i class='bx bx-chevron-down' style="color:#fff;font-size:17px;margin-left:2px;vertical-align:middle;display:inline-block;transform:translateY(-2px)" ></i></p>
              </div>

            </div>

            <div v-on:click='delbox=true' style="width:32px;height:32px;border-radius:5px;background:#323744;margin-left:15px;cursor: pointer;" class="d-flex align-items-center justify-content-center">
              <i class='bx bx-trash' style="color:#fff;font-size: 17px;"  ></i>
            </div>
            <div v-on:click='downloads' style="width:32px;height:32px;border-radius:5px;background:#323744;margin-left:15px;cursor: pointer;" class="d-flex align-items-center justify-content-center">
              <i class='bx bx-cloud-download' style="color:#fff;font-size: 17px;"  ></i>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-3" style="padding:0px">
        <div></div>
      </div>
    </div>
  </div>
   <div class="container-fluid">
     <div class="row" style="position:relative;"> 
 
       <div class="col-md-3 colfull order-2" style="">
        
         <div  style="" class="d-flex flex-column rightside" v-if='comloadedd'>
           
            <div class="  px-3" style="border-bottom: 1px solid #0F0F14;padding:9px 14px;">
              <h2 style="color:#f1f3f6;font-size: 13px;font-weight: 500!important">{{  alldata.uploader.name }} <span style=" color:#636882;font-size: 13px;font-weight: 500!important">uploaded  on {{  alldata.strdate }}</span> </h2>
            </div>
           


<div class="px-3 py-3">
  <p style="color:#636882;font-size: 14px;font-weight: 500;">Members</p>
           <div class="d-flex align-items-center  mt-3">

            <template v-for='itm in alldata.viewedby'>
  
              
               <div :style="{background:itm.color,position:'relative',cursor:'pointer'}" :key='itm.mobile' class="usericons"  >
                  <div class="usericonsub" style="position:absolute;background: #20222B;padding: 10px;border-radius: 5px;top:28px;left:0%;transform: translateX(0%);color: #fff;font-weight: 400;font-size: 12px;display: none;">{{itm.name}}</div>
                <span style="font-size:12px;font-weight: 400;color: #fff;text-transform: uppercase;">{{itm.name[0]}}</span></div>
               
 
             </template>
              
           </div>
         </div>


           <div class="d-flex  px-3 pb-2 pt-2 align-items-center" style="position: relative;border-bottom: 1px solid #0f0f14;">
             <div v-on:click='tabs=0' v-bind:class="{default:true,activess:tabs==0}" style="">
               {{comments.length}} Comments
             </div>
              <div v-on:click='tabs=1'  v-bind:class="{default:true,activess:tabs==1}"  >
              File Information
             </div>
             <div  :class="{'dash1':true,'dash2':tabs==1}"></div>
            
           </div>

            <div class="d-none  p-3 align-items-center" style="position: relative; ">
             
            
           </div>



             <div   v-if="tabs==1" style="flex:1;overflow: scroll;" class=" ">
              <div class="px-2 py-3 d-flex align-items-center  " style="border-bottom:1px solid #0F0F14">
                <div class="d-flex align-items-center" style="width:50%">
                  
                  <h2 style="font-size:14px;font-weight:400;color: #636882;margin-left: 6px;margin-bottom: 0px;">File Name</h2>
                </div>
                <div class="d-flex align-items-start " style="margin-top: 0px;width:50%" >
                
                  <p style="font-weight: 400;color: #b8c1cf;font-size: 13px;    line-height: 18px;margin-bottom: 0px;margin-left: 8px;">{{alldata.name}}</p>
                </div>
              </div>


               <div class="px-2 py-3 d-flex align-items-center  " style="border-bottom:1px solid #0F0F14">
                <div class="d-flex align-items-center" style="width:50%">
                  
                  <h2 style="font-size:14px;font-weight:400;color: #636882;margin-left: 6px;margin-bottom: 0px;">Size</h2>
                </div>
                <div class="d-flex align-items-start " style="margin-top: 0px;width:50%" >
                
                  <p style="font-weight: 400;color: #b8c1cf;font-size: 13px;    line-height: 18px;margin-bottom: 0px;margin-left: 8px;">{{getbyte(alldata.bytes)}}</p>
                </div>
              </div>
<!--

RES 1920 x 1080
FPS 30
codec
encrypt email in share link
slack to main user who comments 
search
sort


annotate
video preview
-->


 <div class="px-2 py-3 d-flex align-items-center  " style="border-bottom:1px solid #0F0F14">
                <div class="d-flex align-items-center" style="width:50%">
                  
                  <h2 style="font-size:14px;font-weight:400;color: #636882;margin-left: 6px;margin-bottom: 0px;">Uploader</h2>
                </div>
                <div class="d-flex align-items-start " style="margin-top: 0px;width:50%" >
                
                  <p style="font-weight: 400;color: #b8c1cf;font-size: 13px;    line-height: 18px;margin-bottom: 0px;margin-left: 8px;">{{  alldata.uploader.name }}</p>
                </div>
              </div>
               <div class="px-2 py-3 d-flex align-items-center  " style="border-bottom:1px solid #0F0F14">
                <div class="d-flex align-items-center" style="width:50%">
                  
                  <h2 style="font-size:14px;font-weight:400;color: #636882;margin-left: 6px;margin-bottom: 0px;">Uploaded Date</h2>
                </div>
                <div class="d-flex align-items-start " style="margin-top: 0px;width:50%" >
                
                  <p style="font-weight: 400;color: #b8c1cf;font-size: 13px;    line-height: 18px;margin-bottom: 0px;margin-left: 8px;">{{  alldata.strdate }}</p>
                </div>
              </div>

 <div class="px-2 py-3 d-flex align-items-center  " style="border-bottom:1px solid #0F0F14">
                <div class="d-flex align-items-center" style="width:50%">
                  
                  <h2 style="font-size:14px;font-weight:400;color: #636882;margin-left: 6px;margin-bottom: 0px;">Duration</h2>
                </div>
                <div class="d-flex align-items-start " style="margin-top: 0px;width:50%" >
                
                  <p style="font-weight: 400;color: #b8c1cf;font-size: 13px;    line-height: 18px;margin-bottom: 0px;margin-left: 8px;">{{ rendermins( alldata.duration )}}</p>
                </div>
              </div>




                
           </div>

           <div   v-if="tabs==0" style="flex:1;overflow: scroll; " class=" ">
 
            <template v-for='itm,index in getcomments'>

              <div> 
              <div  v-on:click='settitmers(itm)' class="px-3 pt-4 pb-2 topmainss" :style="{'background':itm.comselected?'#14161D':'#20222B','borderLeft':itm.comselected?'2px solid #12B789':'none','position':'relative'}">

                <div v-on:click='setmark(itm)' v-if='!itm.status' style="width:15px;height:15px;border-radius:50%;border:1px solid rgb(184, 193, 207);position: absolute;top: 25px;right: 10px;" class="markbtn"></div>
                <div v-on:click='setmark(itm)' v-else style="width:15px;height:15px;border-radius:50%;border:1px solid rgb(184, 193, 207);position: absolute;top: 25px;right: 10px;" class="markbtn  align-items-center justify-content-center">
                   <i    class='bx bx-check'  style="color:rgb(184, 193, 207);font-size:14px" ></i>
                </div>
                <div class="d-flex align-items-center">
                  <div :style="{background:itm.commentby.color}" class="d-flex align-items-center justify-content-center rdsmain"><span style="font-size:14px;font-weight: 400;color: #fff;text-transform: uppercase;">{{itm.commentby.name[0]}}</span></div>
                  <h2 style="font-size:13px;font-weight:400;color: #f9f9f9;margin-left: 6px;margin-bottom: 0px;">{{itm.commentby.name}} <span style="color:rgb(125, 130, 156);font-weight: 400;margin-left: 5px;font-size: 13px">{{itm.strdate}}</span></h2>
                </div>
                <div style="position:relative; " class="likssecmain1">
               





                <div v-if='!itm.selected'   class="d-flex align-items-start " style="margin-top: 6px;" >
                  <h2 style="color: #12B789;font-weight: 500;margin-bottom: 0px;font-size: 14px;transform: translateY(2px);">{{itm.duration}} </h2>
                  <svg width="16" height="15" v-if="itm.acttype=='paint'" xmlns="http://www.w3.org/2000/svg" style='margin-left: 5px;'  alt="Annotation Brush" class="CommentTextContainer__AnnotationBrushIcon-sc-10cr1gs-1 eFwlFQ"><path   d="M15.42 4.598c.373.893.58 1.873.58 2.902 0 4.142-3.35 7.5-7.48 7.5-.07 0-.138-.001-.206-.003a5.975 5.975 0 0 0 1.617-1.665A6 6 0 0 0 14.504 7.5a6.01 6.01 0 0 0-.222-1.625l1.137-1.277zM12.077.902l-.764.733-.054.05-.333.32A5.951 5.951 0 0 0 8.519 1.5c-3.305 0-5.984 2.686-5.984 6 0 .143.005.285.014.426-.516.5-.938 1.08-1.198 1.727A7.519 7.519 0 0 1 1.04 7.5C1.04 3.358 4.389 0 8.52 0c1.289 0 2.501.327 3.56.902zM2.585 10.79c.297-2.196 3.53-3.286 4.239-3.369.848 0 2.257 1.378 2.543 2.526 0 4.207-4.467 5.13-6.782 5.053C.377 14.91-.167 13.335.04 13.316c.537-.044 2.277.577 2.544-2.526zM14.195.684c1.526-1.56 2.136-.026 1.631.842l-4.893 5.711c0 1.026-.815 1.868-.815 1.868 0-.658-.816-2.342-2.446-2.526 0 0 0-.842 1.63-1.026 0 0 3.367-3.308 4.893-4.869z" fill="#12B789"></path></svg>
                  <p style="font-weight: 400;color: #B8C1CF;font-size: 13px;margin-bottom: 0px;margin-left: 8px;    white-space: pre-wrap;" >{{itm.commenttext}}</p>
                </div>
                <div v-if='!itm.selected' class="d-flex align-items-center justify-content-between likssecmain" style="margin-bottom: 20px;margin-top: 10px;">
                  <div class="d-flex align-items-center">
                    <h2 style="font-size:13px;font-weight:400;color: rgb(125, 130, 156);margin-left: 0px;margin-bottom: 0px;cursor: pointer;" v-on:click='setreply(itm)'> <span style="color:#636882;font-weight: 400;margin-left: 0px;">Reply  </span></h2>
                    


                  <h2  style="font-size:13px;font-weight:400;color: #f9f9f9;margin-left: 6px;margin-bottom: 0px;position: relative;cursor: pointer; " class="ssa">


 

                    <i class='bx bx-like likecom' v-on:click='like(itm)' v-if='!itm.likedby.includes(userinfo.name)'  style="color: #636882"  ></i> 
                    <i class='bx bxs-like likecom' v-on:click='like(itm)' v-if='itm.likedby.includes(userinfo.name)'  style="color: #12B789"  ></i> 
                    <span   class="likenum"  :style="{color:itm.likedby.includes(userinfo.name)?'#12B789':'#636882'}">{{itm.likes}} </span>




<div v-if='itm.likes>0' class="usericonsub" style="width: 160px;position:absolute;background: #20222B;padding: 10px;border-radius: 5px;top:28px;left:-30px ;color: #fff;font-weight: 400;font-size: 12px;display: none;z-index: 100000000;">liked by <template v-for='itmm in itm.likedby'><span style="font-size:13px;font-weight: 400;color: #f1f1f1; ">{{itmm}}, </span></template></div>



                  </h2>
                  </div>
                  <div class="likssec" style="opacity:0;transition:all 0.3s">
                   
                     <i class='bx bxs-edit-alt'  v-on:click='setedit(itm,index)'  style="font-size:16px;font-weight:400;color: #636882;margin-left: 0px;margin-bottom: 0px;cursor: pointer;"  ></i>
                      <i class='bx bx-trash-alt' v-on:click='deletecon(itm)' style="font-size:16px;font-weight:400;color: #636882;margin-left: 6px;margin-bottom: 0px;cursor: pointer;"  ></i>
                  </div>
                </div>


                   <div v-if='itm.selected'  style="background: transparent;;padding: 0px;z-index: 10000000;padding-bottom: 30px; margin-top: 6px;">
                    <form v-on:submit.prevent='editcomment(itm)'>
                      <div class="mb-2">
                        <textarea type="text" v-on:keydown='incheieditcom($event,itm)' required v-on:paste='chfocus($event)'  v-model='itm.editcontent' class="form-control sssa" style="background:#0F0F14;outline:none;border:1px solid #939393;box-shadow: none;color: rgb(184, 193, 207); transition: height 1s!important;font-size: 13px;" name=""></textarea>
                      </div>
                    <div class="d-flex align-items-center justify-content-end">
                          <p v-on:click='canceledit(itm)'  style=" border:none;outline: none; color: #7d829c;font-weight: 400;font-size: 13px;background: transparent;cursor: pointer;margin-bottom: 0px;">Cancel</p>
                                           



                    </div>
                    </form>
                  </div>

                    <div v-if='itm.selectedreply'    style=" background: transparent;;padding: 0px;z-index: 10000000;padding-bottom: 20px; ">
                    <form id="repform" v-on:submit.prevent='addreply(itm)'>
                      <div class="mb-2">
                        <textarea type="text" v-on:keydown='incheireply($event,itm)' required v-model='itm.replycontent' class="form-control" style="background:#0F0F14;outline:none;border:1px solid #939393;box-shadow: none;color: rgb(184, 193, 207);font-size: 13px;" name=""></textarea>
                      </div>
                    <div class="d-flex align-items-center justify-content-end">
                       <p v-on:click='addreply(itm)' v-if="itm.replycontent!=''"   style=" border:none;outline: none; color: #fff;font-weight: 400;font-size: 13px;background: transparent;cursor: pointer;margin-bottom: 0px;margin-right: 10px;
 ">Save </p>
  <p   v-else   style=" border:none;outline: none; color: #7d829c;font-weight: 400;font-size: 13px;background: transparent;cursor: pointer;margin-bottom: 0px;margin-right: 10px;
 ">Save </p>
                          <p v-on:click='cancelreply(itm)'  style=" border:none;outline: none; color: #7d829c;font-weight: 400;font-size: 13px;background: transparent;cursor: pointer;margin-bottom: 0px;">Cancel</p>
                                                 

                    </div>
                    </form>
                  </div>



              </div>

            </div>




  <template v-for='(item,index) in itm.reply'>
                <div class="  p-3 repsecmain1" style="border-bottom:1px solid #0F0F14;padding-left: 50px!important;">
                <div class="d-flex align-items-center">
              
                  <div :style="{background:item.commentby.color}" class="d-flex align-items-center justify-content-center rdsmain"><span style="font-size:14px;font-weight: 400;color: #fff;text-transform:uppercase;">{{item.commentby.name[0]}}</span></div>

                  <h2 style="font-size:13px;font-weight:400;color: #f9f9f9;margin-left: 6px;margin-bottom: 0px;">{{itm.commentby.name}} <span style="color:rgb(125, 130, 156);font-weight: 400;margin-left: 5px;font-size: 13px">{{itm.strdate}}</span></h2>
                </div>
                <div style="position:relative; " class="repsecmain">
                  
                   
   <div v-if='item.selected'  style=" background: transparent;;padding: 0px;z-index: 10000000;padding-left: 30px;margin-top: 6px; ">
                    <form v-on:submit.prevent='editcommentreply(item,itm)'>
                      <div class="mb-2">
                           <textarea type="text" v-on:paste='chfocus($event)' v-on:keydown='incheieditcomrep($event,item,itm)' required autofocus   v-model='item.editcontent' class="form-control reptext" style="background:#0F0F14;outline:none;border:1px solid #939393;box-shadow: none;color: rgb(184, 193, 207);font-size: 13px;"  name=""></textarea>
                      </div>
                    <div class="d-flex align-items-center justify-content-end">
                          <p v-on:click='cancelselrep(item,itm)'  style=" border:none;outline: none; color: #7d829c;font-weight: 400;font-size: 13px;background: transparent;cursor: pointer;margin-bottom: 0px;">Cancel</p>
                                                  <button style=" border:none;outline: none; color: rgb(184, 193, 207);font-weight: 400;font-size: 13px;background: transparent;margin-left: 5px;">Save</button>

                    </div>
                    </form>
                  </div>


                <div v-if='!item.selected' class="d-flex align-items-start " style="margin-top: 6px;" >
                 
                  <p style="font-weight: 400;color: #B8C1CF;font-size: 13px;margin-bottom: 0px;margin-left: 8px;white-space: pre-wrap;">{{item.commenttext}}</p>
                </div>



                 <div v-if='!item.selected' class="d-flex align-items-center justify-content-end mt-2  repsec">
                   <h2  style="font-size:13px;font-weight:400;color: #f9f9f9;margin-left: 6px;margin-bottom: 0px;position: relative;cursor: pointer; " class="ssa">
                    <i class='bx bx-like' v-if='!item.likedby.includes(userinfo.name)'  v-on:click='likereply(item,itm)' style="font-size:16px;font-weight:400;color: #636882;margin-left: 6px;margin-bottom: 0px;cursor: pointer;vertical-align: middle;"  ></i>

                      <i class='bx bxs-like' v-if='item.likedby.includes(userinfo.name)'  v-on:click='likereply(item,itm)' style="font-size:16px;font-weight:400;color: #12B789;margin-left: 6px;margin-bottom: 0px;cursor: pointer;vertical-align: middle;"  ></i>

                     <span  class="likenum"  :style="{color:item.likedby.includes(userinfo.name)?'#12B789':'#636882'}">{{item.likes}} </span>


 

<div v-if='item.likes>0' class="usericonsub" style="width: 160px;position:absolute;background: #20222B;padding: 10px;border-radius: 5px;top:28px;left:-30px ;color: #fff;font-weight: 400;font-size: 12px;display: none;">liked by <template v-for='itmdm in item.likedby'><span style="font-size:13px;font-weight: 400;color: #f1f1f1; ">{{itmdm}}</span></template></div>



                  </h2>

                     <i class='bx bxs-edit-alt'   v-on:click='seteditreply(item,itm,index)'  style="font-size:16px;font-weight:400;color: #636882;margin-left: auto;margin-bottom: 0px;cursor: pointer;opacity: 0;transition: all 0.3s;"  ></i>
                      <i class='bx bx-trash-alt' v-on:click='deleteconreply(item,itm)' style="font-size:16px;font-weight:400;color: #636882;margin-left: 6px;margin-bottom: 0px;cursor: pointer;opacity: 0;transition: all 0.3s;"  ></i>
                  </div>
                 
              </div>
              </div>
            </template>




            </div>


              </template>
               
           </div>
         </div> 



       </div>
       <div class="cuswidth2 order-1 h60px" style='padding:0px;height:calc(100vh - 30px);'>
         <div style='height: 100%;' class="msh100">
           
 
           <div style="height: 100%;" class="">
              <div class="container-fluid"  style="height: 100%;" >
                <div class="row justify-content-center"  style="height: 100%;position: relative;" >


                  
                    <div class="  col-md-9 colfull col-12 d-flex flex-column justify-content-between h60px " style="padding: 0px;margin-top:60px;height: calc(100% - 60px);padding-bottom: 40px;position: relative;">
                      <div   :style="{'position':'relative',margin:'0 auto',width:'100%'}">

                          <div v-on:click='pausevid'   style="position: absolute;top: 0;left: 0;right: 0;bottom: 0; z-index: 100;cursor: pointer;">
                            <img src="https://firebasestorage.googleapis.com/v0/b/staging-wlshop.appspot.com/o/Untitled%20design%20(1).png?alt=media&token=1decdb99-af63-4817-9cba-1541d9c9fcbd" style="width:100%;height:100%;object-fit: cover;">
                          </div>
                          <video    playsinline  crossorigin='*'  style="width:100%;height: auto;border:none;outline: none;box-shadow: none; position: absolute;   top: 0;left: 0;right: 0;bottom: 0;" controls >
                            <source :src="alldata.video"  type="video/mp4"  >
                          </video>
 



                          <div class="d-flex    mt-0" style="position: absolute;
    width: 100%;
    margin: 0px auto;
 bottom: -30px;
    border-bottom: 1px solid #0f0f14;
    height: 20px;
  z-index: 100000000000;
    display: block;">
                            
                          
                          <template v-for='(itm,index) in getdatas'>

                            <div  v-on:click='settitmers(itm)' class="rds d-flex align-items-center justify-content-center" :style="{left:itm.hovtime,background:itm.commentby.color,zIndex:index=index+1}">
                                                             <span style="font-size:9px;font-weight: 400;color: #fff;text-transform: uppercase;line-height: 0;">{{itm.commentby.name[0]}}</span>

                              <div class="rdspos ">
                                 <div class="d-flex align-items-center">
                  <div   :style="{background:itm.commentby.color}"class="d-flex align-items-center justify-content-center rdssub"><span style="font-size:14px;font-weight: 400;color: #fff">{{itm.commentby.name[0]}}</span></div>
                  <h2 style="font-size:13px;font-weight:400;color: #f9f9f9;margin-left: 6px;margin-bottom: 0px;">{{itm.commentby.name}} <span style="color:#636882;font-weight: 300;margin-left: 5px;">{{itm.time}}</span></h2>
                </div>
                
                <div class="d-flex align-items-start " style="margin-top: 12px;" >
                  <h2 style="color: #12B789;font-weight: 500;margin-bottom: 0px;font-size: 12px;transform: translateY(3px);">{{itm.duration}}</h2>
                  <p style="font-weight: 400;color: #B8C1CF;font-size: 13px;margin-bottom: 0px;margin-left: 8px;">{{itm.commenttext}}</p>
                </div>
                              </div>
                            </div>
                          </template>
                          </div>





                        <div style="position:absolute;top: 0;left: 0;right: 0;bottom: 0;"  v-if='imagebox'  v-on:click='playvid' > 
                          <div style="position:absolute;top: 0;left: 0;width: 100%;" id="dupekl"></div>

                           <div  v-on:click='playvid'   style="position:absolute;top: 0;left: 0;width: 100%; z-index: 1000000000;cursor: pointer;" >
                             <img :src="setimgaedata" style="width:100%">
                           </div>

                      
                        </div>
                      </div>
                      {{evtlist}}
                      {{reevtlist}}
                      <form v-on:submit.prevent='addcoment' class="w70"  style="background: #2B2E3B;padding: 0px;border-radius: 6px;margin:  0px auto;box-shadow: rgb(0 0 0 / 50%) 0px 5px 30px 0px;margin-top: 78px;position: relative;z-index: 1;">

                        <div style="height:50px;position:relative;">
                        <div class="d-flex align-items-start" style="position:absolute;bottom: 0;left: 0;right: 0;background: #2b2e3b;padding: 20px;padding-bottom: 0px;border-radius: 6px;">
                           
                                          <div :style="{background:alldata.uploader.color}" class="usericon"  ><span style="font-size:14px;font-weight: 400;color: #fff;text-transform: uppercase;">{{alldata.uploader.name[0]}}</span></div>



                           <div style="flex:1">

                             <textarea v-on:keydown='inchei($event)'   v-on:paste='chfocus($event)'  v-model='comm' required type="text" style="border:none;width:100%;outline:none;background: transparent;padding-left: 15px;font-size: 15px;font-weight: 400;color:rgb(184, 193, 207);height: auto;resize: none; max-height: 200px;" rows="1"  id="inch"  class="comt   " placeholder="Leave your comment here..." name=""></textarea> 

                           </div>
                        </div> 
                      </div>

                
 
                        <div class="d-flex align-items-center justify-content-between mt-3" style="padding:20px;padding-top: 0px;">
                          <div  class="d-flex align-items-center" style="background:#20222b;padding: 5px;border-radius: 4px;">
                            <i  style="color:#12b789;font-size: 18px;margin-right: 5px;transform: translateY(1px);" class='bx bx-time-five'></i>
                            <p style="color:#12b789;font-weight: 600;font-size: 14px;margin-bottom: 0px;">{{duration}}</p>
                          </div>

                          <div class="d-flex align-items-center" style="cursor:pointer;" > 
                         

                         
                          <div v-if="comm==''" id="sendbtn" style="padding: 3px 8px;background:#757C89;opacity:0.4;color: #fff;font-weight: 500;font-size: 13px;border-radius: 5px;cursor: pointer;margin-left: 16px;">Send</div>
                          <button v-else id="sendbtn" style="padding: 3px 8px;background:#12b789; color: #fff;font-weight: 500;font-size: 13px;border-radius: 5px;cursor: pointer;margin-left: 16px;border:none;outline:none;">Send</button> 
                        </div>

                        </div>
                      </form>
                    </div>
      
                   {{offplay}}



                </div>
              </div>
           </div>
          
         </div>
       </div>
     </div>
   </div>
 </div>
</template>

<script>
  const fb = require('../firebase/firebaseconfig.js')
 import axios from 'axios'
 var x='sssss'

export default {
 
   

      props:['wlgigs','loaded','signedin','countrycode','fav','favall','wlgigobj','userinfo','userdataloaded'],
  data () {

        return{
   signedinby:'google',
   foldervisible:true,
scrbox:false,
loadedd:false,
cdura:'',
playstatus:false,
markerArea:null,
   name:'',
   playspeed:1,
   chid:'',
   capbox:false,
   timeseconds:0,
   myuid:'',
   tempdata:{},
   imagebox:false,
  setimgaedata:'',
   deletebox:false,
   prevval:false,
   teststatus:true,
   status:0,
   heivid:0,
widvid:0,
    tempreply:{},
          deleteboxreply:false,
   comm:'',
   comloadedd:false,
   imagess:'',
   allas:[{name:'ef'},{name:'ef'}],
   editbox:false,tabs:0,
   statusbox:false,
   formsubmited:false,
   addboxs:false,
   duration:'00:00',
   cid:'',
   tab:0,
   editdata:{},
   question:[{
    id:0,
    title:'Enter your Name',
    answer:'',
    type:'input',
    error:false,
   },
   {
    id:1,
    title:'What would you like to do?',
    answer:'',
    type:'option',
    options:['Extend Video','Hold Video','Resume Video','Set Deadline After Feedback'],
      error:false,
   }],
   deldata:{},
   delbox:false,
   bid:'',
   addbox:false,
   editboxsss:false,
   profiletext:'',
   leads:[],
   tempmanager:null,
   cusitems:{  x:150,
  y:150,
  width:300,
  height:300,
  angle:0,}, 
   items:{
  x:150,
  y:150,
  width:300,
  height:300,
  angle:0,

},
alldata:{},
   drawer:false,
   name:'',
   searchtxt:'',
 key:'all',
 comments:[],

 
        }
     
    
  },
    created(){
 

/*



 
 //w/h=0.5
 
 var pheight=600

 var w = 0.5*(600 - 200)
 


*/



 var vm=this
 
if(fb.auth.currentUser!=null){
 



 
fb.db.collection("wlframeprojects").doc(this.$route.query.folder).collection('videos').doc(this.$route.query.id)
    .onSnapshot((doc) => {
        console.log("Current data: ", doc.data());

        vm.alldata={
          ...doc.data()
        }


 

    var x = document.createElement("VIDEO");

      x.setAttribute("src",vm.alldata.video);
      x.setAttribute("class",'disa');

     // document.body.appendChild(x)
 



x.addEventListener( "loadedmetadata", function (e) {
 
    var width = this.videoWidth;
  
        var height = this.videoHeight;


vm.widvid=width-(window.innerHeight-100)
 
 
     console.log('video width:'+width)
console.log('video height:'+height)

 

}, false );



        var x=vm.alldata.viewedby.filter((itm)=>{
                return itm.email==fb.auth.currentUser.email
        })
        if(x.length>0){

        }else{




var docRef =  fb.db.collection("wlframeusers").doc(fb.auth.currentUser.uid);

docRef.get().then((doc) => {
    if (doc.exists) {
       
  
          fb.db.collection("wlframeprojects").doc(this.$route.query.folder).collection('videos').doc(this.$route.query.id).update({
viewedby:[
...vm.alldata.viewedby,
{
  ... doc.data(),
  ids:doc.id
}

]

          })
 } 
}).catch((error) => {
    console.log("Error getting document:", error);
});






        }

      vm.status=vm.alldata.status
        vm.loadedd=true
    });

fb.db.collection("wlframeprojects").doc(this.$route.query.folder).collection('videos').doc(this.$route.query.id).collection('comments').orderBy('createdon','desc').onSnapshot((querySnapshot) => {
        var comments = [];
        querySnapshot.forEach((doc) => {
            comments.push({...doc.data(),ids:doc.id,comselected:false});
        });
    

    vm.comments=[
  ...comments]

 vm.comloadedd=true

      });
}



  },
  mounted(){ 


 
 


 

} ,

destroyed(){
 



}
   ,
  computed:
  {
 
 offplay(){
  var vm=this
   console.log(vm.comm)

  setTimeout(()=>{
    if(!vm.prevval && vm.comm!=''){


const video = document.querySelector('video');
 
if(video.paused){
  vm.prevval=false
}else{
  vm.prevval=true
}
console.log(vm.prevval)
if(vm.comm!='' && vm.prevval){
    const video = document.querySelector('video');
  video.pause()
}
  }

  },10)
 
 },

 getcomments(){
 


var x=this.comments.map((itm)=>{

 
var dates=itm.date.split(':')[2]+'/'+itm.date.split(':')[1]+'/'+itm.date.split(':')[0]
 
var cdates=new Date().getFullYear()+'/'+(new Date().getMonth()+1)+'/'+new Date().getDate()


var today =new Date()
var fdate=new Date(dates)
var days=0
while(fdate<=today){
days=days+1
fdate.setDate(fdate.getDate()+1)
}

if(dates==cdates){

var replys=itm.reply.map((itms)=>{
 return {
    ...itms,
    strdate:'Just now' 
  }


})

return {
    ...itm,
    strdate:'Just now', 
    reply:[
    ...replys]
  }

}
else if(days<=7){


var replys=itm.reply.map((itms)=>{

var datess=itms.date.split(':')[2]+'/'+itms.date.split(':')[1]+'/'+itms.date.split(':')[0]
var todays =new Date()
var fdates=new Date(datess)
var dayss=0
while(fdates<=todays){
dayss=dayss+1
fdates.setDate(fdates.getDate()+1)
}

if(dayss<=7){
return {
    ...itms,
    strdate:dayss+'d' 
  }
  }

  else if(dayss>=8 && dayss<=30){
  var sdates = new Date()
var firstJanuarys = new Date(sdates.getFullYear(), 0, 1);
  var dayNrs = Math.ceil((sdates - firstJanuarys) / (24 * 60 * 60 * 1000));
  var weekNrs = Math.ceil((dayNrs + firstJanuarys.getDay()) / 7);
  
return {
    ...itm,
    strdate:weekNrs+'w ago' 
  }
}else if(dayss>=31){

 

return {
    ...itm,
    strdate:Math.round(dayss/30)+'mo ago' 
  }
}



})

return {
    ...itm,
    strdate:days+'d',
    reply:[
    ...replys]
  }


}else if(days>=8 && days<=30){
  var sdate = new Date()
var firstJanuary = new Date(sdate.getFullYear(), 0, 1);
  var dayNr = Math.ceil((sdate - firstJanuary) / (24 * 60 * 60 * 1000));
  var weekNr = Math.ceil((dayNr + firstJanuary.getDay()) / 7);
  

  var replys=itm.reply.map((itms)=>{

var datess=itms.date.split(':')[2]+'/'+itms.date.split(':')[1]+'/'+itms.date.split(':')[0]
var todays =new Date()
var fdates=new Date(datess)
var dayss=0
while(fdates<=todays){
dayss=dayss+1
fdates.setDate(fdates.getDate()+1)
}

if(dayss<=7){
return {
    ...itms,
    strdate:dayss+'d' 
  }
  }

  else if(dayss>=8 && dayss<=30){
  var sdates = new Date()
var firstJanuarys = new Date(sdates.getFullYear(), 0, 1);
  var dayNrs = Math.ceil((sdates - firstJanuarys) / (24 * 60 * 60 * 1000));
  var weekNrs = Math.ceil((dayNrs + firstJanuarys.getDay()) / 7);
  
return {
    ...itm,
    strdate:weekNrs+'w ago' 
  }
}else if(dayss>=31){

 

return {
    ...itm,
    strdate:Math.round(dayss/30)+'mo ago' ,
    reply:[...replys]
  }
}



})


return {
    ...itm,
    strdate:weekNr+'w ago' 
  }
}else if(days>=31){

 var replys=itm.reply.map((itms)=>{

var datess=itms.date.split(':')[2]+'/'+itms.date.split(':')[1]+'/'+itms.date.split(':')[0]
var todays =new Date()
var fdates=new Date(datess)
var dayss=0
while(fdates<=todays){
dayss=dayss+1
fdates.setDate(fdates.getDate()+1)
}

if(dayss<=7){
return {
    ...itms,
    strdate:dayss+'d' 
  }
  }

  else if(dayss>=8 && dayss<=30){
  var sdates = new Date()
var firstJanuarys = new Date(sdates.getFullYear(), 0, 1);
  var dayNrs = Math.ceil((sdates - firstJanuarys) / (24 * 60 * 60 * 1000));
  var weekNrs= Math.ceil((dayNrs + firstJanuarys.getDay()) / 7);
  
return {
    ...itm,
    strdate:weekNrs+'w ago' 
  }
}else if(dayss>=31){

 

return {
    ...itm,
    strdate:Math.round(dayss/30)+'mo ago' 
  }
}



})

return {
    ...itm,
    strdate:Math.round(days/30)+'mo ago' ,
    reply:[...replys]
  }
}


  
})
return x
 },
 

 getdatas(){


if(this.cdura!=''){
var x=this.comments.map((itm)=>{

return {
  ...itm,
  hovtime:((100 * itm.seconds) / this.cdura)+'%'
  
}
})

console.log(x)
 
return x.reverse()
}else{
  return []
}

 },
 
 reevtlist(){
  var vm=this
   setTimeout(()=>{



 
  document.addEventListener("keydown", function(e) {
  e = e || window.event;
 


 
   if(e.keyCode==68  && e.target != document.getElementById('inch') && !vm.capbox){

 vm.playspeed=vm.playspeed+0.5
const video = document.querySelector('video');
document.querySelector('video').playbackRate =  vm.playspeed;
 document.querySelector('video').play()

}
   if(e.keyCode==83 && e.target != document.getElementById('inch') && !vm.capbox ){
 
 const video = document.querySelector('video');
 if(video.paused){
  video.play()
 }else{
  video.pause()

 }
}
  if(e.keyCode==65  && e.target != document.getElementById('inch') && !vm.capbox){
 vm.playspeed=vm.playspeed-0.5
const video = document.querySelector('video');
document.querySelector('video').playbackRate =  vm.playspeed;

}

   if(e.keyCode == 32 && e.target == document.body) {

    e.preventDefault()

  }


  if(e.keyCode==32 && e.target != document.getElementById('inch')){
 
var status=true

 var x=document.getElementsByTagName('input')
  
for(var i=0;i<x.length;i++){
   if(x[i] === document.activeElement){
    status=false
  }
}

 
 if(status){
   
  const video = document.querySelector('video');
 if(video.paused){
  video.play()
 }else{
  video.pause()

 }
}

 }
});


},10)
 },
 evtlist(){

  



  var vm=this

 
//"mtn -i -t -v -P -c 3 -r"+cols+" ./static/uploads/"+filnamewithext
setTimeout(()=>{
  const player = new Plyr('video',{
  hideControls:false,
  invertTime:false,
  previewThumbnails:{ enabled: true, src:vm.alldata.previewlink },
  controls:['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'captions', 'settings', 'pip', 'airplay', 'fullscreen'],
   markers:{ enabled: false, points: [{ time: 56, label: 'string' }] }
 });

 
window.player = player;





const video = document.querySelector('video');

 

video.addEventListener('canplay', (event) => {
 vm.cdura=video.duration
  })
 
video.addEventListener('play', (event) => {
 

 
   var seconds =  event.target.duration


  console.log(seconds)
 vm.imagess=''
vm.imagebox=false
vm.playstatus=true

 vm.playspeed=1.0
const video = document.querySelector('video');
document.querySelector('video').playbackRate =  vm.playspeed;


 })
video.addEventListener('timeupdate', (event) => {
 
 


 var timestamp = event.target.currentTime;

// 2
var hours = Math.floor(timestamp / 60 / 60);

// 37
var minutes = Math.floor(timestamp / 60) - (hours * 60);

// 42
var seconds = timestamp % 60;



vm.timeseconds=timestamp

var preseconds=seconds.toString().split('.')[0];

var premins=minutes.toString().split('.')[0];


 
if(preseconds.length==1){

 
  preseconds='0'+preseconds
} 
if(premins.length==1){
  premins='0'+premins
} 

if(timestamp>3600){
var formatted = hours+':'+  premins + ':' + preseconds

}else{
  var formatted =   premins + ':' + preseconds

}




vm.duration=formatted


});
  },10)
 },
  getDarkColor() {
    var color = '#';
    for (var i = 0; i < 6; i++) {
        color += Math.floor(Math.random() * 10);
    }
    return color;
},
 

  },

   
  methods:{ 
    playvid(){
let video = document.querySelector('video')
video.play()
    },
    pausevid(){

let video = document.querySelector('video')
if(video.paused){
video.play()
}else{
 video.pause() 
}

this.playstatus=false
    },
    rendermins(date){
 



if(Number(date)>3600){
 var hours = Math.floor(date / 60 / 60);
  var seconds = Math.floor(date % 60)
  var hr= hours.toString().length==1?'0'+hours:hours

var mn= (Math.floor(date / 60) - (hours * 60)).toString().length==1?'0'+(Math.floor(date / 60) - (hours * 60)):(Math.floor(date / 60) - (hours * 60))
var sc= seconds.toString().length==1?'0'+seconds:seconds
return  hr+':'+mn+':'+sc
}else{

 var hours = Math.floor(date / 60 / 60);
  var seconds = Math.floor(date % 60)
var mn= (Math.floor(date / 60) - (hours * 60)).toString().length==1?'0'+(Math.floor(date / 60) - (hours * 60)):(Math.floor(date / 60) - (hours * 60))
var sc= seconds.toString().length==1?'0'+seconds:seconds
return  mn+':'+sc

}
},
    chfocus(event){
      console.log(event)

        setTimeout(()=>{


 
       event.target.style.height = 'auto';
  event.target.style.height = (event.target.scrollHeight) + 'px';
   },0)
    },
    inchei(event){
      if(event.which === 13 && !event.shiftKey) {
        event.preventDefault();


       if(this.comm.length>0){
  this.addcoment()
       }else{
         alert('add comment')
       }
             document.getElementById('inch').style.height = 'auto';

       return 
    }

      setTimeout(()=>{


      console.log(document.getElementById('inch').scrollHeight+'---')

       document.getElementById('inch').style.height = 'auto';
  document.getElementById('inch').style.height = (document.getElementById('inch').scrollHeight) + 'px';
   },0)
    },
     incheireply(event,itm){



       if(event.which === 13 && !event.shiftKey) {
        event.preventDefault();
       if(itm.replycontent.length>0){
            this.addreply(itm)

            
       }else{
         alert('add reply')
       }
 event.target.style.height = 'auto';
       return 
    }

      console.log(event.target)

      setTimeout(()=>{


 
       event.target.style.height = 'auto';
  event.target.style.height = (event.target.scrollHeight) + 'px';
   },0)

    },
    incheieditcomrep(event,item,itm){



       if(event.which === 13 && !event.shiftKey) {
        event.preventDefault();
       if(item.editcontent.length>0){
            this.editcommentreply(item,itm)

            
       }else{
         alert('add reply')
       }
 event.target.style.height = 'auto';
       return 
    }

      console.log(event.target)

      setTimeout(()=>{


 
       event.target.style.height = 'auto';
  event.target.style.height = (event.target.scrollHeight) + 'px';
   },0)

    },
incheieditcom(event,itm){



       if(event.which === 13 && !event.shiftKey) {
        event.preventDefault();
       if(itm.editcontent.length>0){
            this.editcomment(itm)

            
       }else{
         alert('add reply')
       }
 event.target.style.height = 'auto';
       return 
    }

      console.log(event.target)

      setTimeout(()=>{


 
       event.target.style.height = 'auto';
  event.target.style.height = (event.target.scrollHeight) + 'px';
   },0)

    },
    likereply(item,itm){



     

if(item.likedby.includes(this.userinfo.name)){


 
  var x=item.likedby.filter((istm)=>{
return istm!=this.userinfo.name

})

      var main=itm.reply.map((im)=>{

                 if(im.id==item.id){
                  return {
                    ...im,
                    likes:im.likes-1,
                    likedby:[...x]
                  }
                 }else{
                  return im
                 } 
          })
 
 fb.db.collection("wlframeprojects").doc(this.$route.query.folder).collection('videos').doc(this.$route.query.id).collection('comments').doc(itm.ids).update({
  reply:[
  ...main
  ]
 })



}else{

      var main=itm.reply.map((im)=>{

                 if(im.id==item.id){
                  return {
                    ...im,
                    likes:im.likes+1,
                    likedby:[...im.likedby,this.userinfo.name]
                  }
                 }else{
                  return im
                 } 
          })
 
 fb.db.collection("wlframeprojects").doc(this.$route.query.folder).collection('videos').doc(this.$route.query.id).collection('comments').doc(itm.ids).update({
  reply:[
  ...main
  ]
 })


}

    },
    like(itm){
 


if(itm.likedby.includes(this.userinfo.name)){


var x=itm.likedby.filter((istm)=>{
return istm!=this.userinfo.name

})
 fb.db.collection("wlframeprojects").doc(this.$route.query.folder).collection('videos').doc(this.$route.query.id).collection('comments').doc(itm.ids).update({
  likedby:[
  ...x
  ],
  likes:itm.likes-1
 })



}else{


 fb.db.collection("wlframeprojects").doc(this.$route.query.folder).collection('videos').doc(this.$route.query.id).collection('comments').doc(itm.ids).update({
  likedby:[
  ...itm.likedby,
  this.userinfo.name
  ],
  likes:itm.likes+1
 })

}

    },
    setmark(item){
 
 var vm=this
fb.db.collection("wlframeprojects").doc(vm.$route.query.folder).collection('videos').doc(vm.$route.query.id).collection('comments').doc(item.ids).update({
  status:!item.status
}).then(()=>{
  
})
    },
captures(){


 /* var bodyRect = document.body.getBoundingClientRect(),
    elemRect = document.getElementById('sendbtn').getBoundingClientRect(),
    offset   = elemRect.top - bodyRect.top;

   
1208.375  --- 853.6250
    */
  const rect = document.getElementById('sendbtn').getBoundingClientRect()
var left=rect.left + window.scrollX
var  top=  rect.top + window.scrollY
 

 
   this.scrbox=true

this.capbox=true
var vm=this
   setTimeout(()=>{


let canvas = document.createElement('canvas');
let video = document.querySelector('video')
video.pause()
let image = '';
   canvas.width = video.clientWidth;
    canvas.height = video.clientHeight;

    let ctx = canvas.getContext('2d');
    ctx.drawImage( video, 0, 0, canvas.width, canvas.height );

    image = canvas.toDataURL('image/jpeg');
console.log(image)
this.imagess=image
     document.getElementById('imgetst').src=image

      var target=document.getElementById('imgetst') 
 
      this.markerArea = new markerjs2.MarkerArea(target);
var vm=this
 this.markerArea.renderImageQuality = 1.0;
this.markerArea.renderAtNaturalSize = true;


this.markerArea.addEventListener("beforeclose", (event) => {
  vm.capbox=false

});
      this.markerArea.addEventListener("render", (event) => {

 

 var x=vm.comm

fb.db.collection("wlframeprojects").doc(vm.$route.query.folder).collection('videos').doc(vm.$route.query.id).update({
  commentcount:Number(vm.alldata.commentcount)+1
})

fb.db.collection("wlframeprojects").doc(vm.$route.query.folder).collection('videos').doc(vm.$route.query.id).collection('comments').add({


 
 
  


commentby:{...vm.userinfo},
commenttext:vm.comm,
date:new Date().getDate()+':'+(new Date().getMonth()+1)+':'+new Date().getFullYear(),
time:new Date().getHours()+':'+new Date().getMinutes(),
status:false,
duration:vm.duration,
selected:false,
likedby:[],
reply:[],
likes:0,
selectedreply:false,
      replycontent:'',
      seconds:vm.timeseconds,
createdon:new Date(),
readby:0,
type:'main',
selected:false,
imgdata:event.dataUrl,
acttype:'paint',
editcontent:'',
id:Math.round(Math.random()*1000000000)

}).then(()=>{
  vm.comm=''
    var x=document.getElementsByTagName('input')
 
 
for(var i=0;i<x.length;i++){
  x[i].blur()
}
setTimeout(()=>{
    document.getElementById('inch').style.height = 'auto';
  },100)
})





  const video = document.querySelector('video');
 
if(vm.prevval){
   video.play()
   vm.prevval=false
}
 
vm.capbox=false

      });
      this.markerArea.show();


 document.getElementsByClassName('__markerjs2_toolbar')[0].style.left=(left-350)+'px'
 document.getElementsByClassName('__markerjs2_toolbar')[0].style.top=(top-14)+'px'
 document.getElementsByClassName('__markerjs2_toolbar')[0].style.display='flex!important'
 





   },10)

},
 showMarkerArea(targ) {
    var target=document.getElementById('imgetst') 
 
      const markerArea = new markerjs2.MarkerArea(target);

      markerArea.addEventListener("render", (event) => (target.src = event.dataUrl));
      markerArea.show();
    },
    settitmers(itm){
console.log(itm)
  const video = document.querySelector('video');

  console.log(itm.seconds)
  video.currentTime = itm.seconds;

  this.setimgaedata=itm.imgdata
  this.imagebox=true

  video.pause()

var x=this.comments.map((itms)=>{
  if(itms.id==itm.id){
    return{
      ...itms,
      comselected:true
    }
  }else{
    return {
      ...itms,
      comselected:false
    }
  }
})


this.comments=[
...x
]

    },

deletevideo(){
  var vm=this
  var prevlink=vm.alldata.previewlink
 fb.db.collection("wlframeprojects").doc(this.$route.query.folder).collection('videos').doc(this.$route.query.id).delete().then(()=>{


  fetch("https://nextjs.getsitewp.com:5000/delfile?fpath="+prevlink, {
        method: 'GET',
         headers: {
           
        }
    })
        .then((res) =>  console.log(res))
        .catch((err) => ("Error occured", err));





this.$router.go(-1)

 })
},
    addreply(item){
 var vm=this
var newreply={
  commentby:{...vm.userinfo},
commenttext:item.replycontent,
date:new Date().getDate()+':'+(new Date().getMonth()+1)+':'+new Date().getFullYear(),
time:new Date().getHours()+':'+new Date().getMinutes(),
status:false,
duration:vm.duration,
selected:false,
likes:0,
likedby:[],
 
selectedreply:false,
replycontent:'',
createdon:new Date(),
readby:0,
type:'sub',
selected:false,
editcontent:'',
id:Math.round(Math.random()*1000000000)
}
 fb.db.collection("wlframeprojects").doc(this.$route.query.folder).collection('videos').doc(this.$route.query.id).collection('comments').doc(item.ids).update({
  reply:[
  ...item.reply,
newreply
  ]
 }).then((itn)=>{
 fb.db.collection("wlframeprojects").doc(this.$route.query.folder).collection('videos').doc(this.$route.query.id).update({
  commentcount:Number(this.alldata.commentcount)+1
})
 })


    },
    setreply(itm){

        


   var x=this.comments.map((itms)=>{
          if(itms.id==itm.id){
         
 return {
  ...itms,
  selectedreply:true,
  }
          }else{
            return itms
          }
        })


        this.comments=[
        ...x
        ]


       
    },
    cancelreply(itm){


   var x=this.comments.map((itms)=>{
          if(itms.id==itm.id){
            
 return {
  ...itms,
  selectedreply:false,
  }
          }else{
            return itms
          }
        })


        this.comments=[
        ...x
        ]
      }, 
    canceledit(itm){
   
        var x=this.comments.map((itms)=>{
          if(itms.id==itm.id){
 return {
  ...itms,
  selected:false,
  }
          }else{
            return itms
          }
        })


        this.comments=[
        ...x
        ]
    },
    setedit(itm,index){
         
        
        var x=this.comments.map((itms)=>{
          if(itms.id==itm.id){
 return {
  ...itms,
  selected:true,
  editcontent:itm.commenttext
 }
          }else{
             return {
  ...itms,
  selected:false,
  editcontent:''
 }
          }
        })


        this.comments=[
        ...x
        ]


     setTimeout(()=>{
  


console.log(document.getElementsByClassName('sssa')[0].scrollHeight+'----')
 
      document.getElementsByClassName('sssa')[0].style.height = 'auto';
document.getElementsByClassName('sssa')[0].style.height = (document.getElementsByClassName('sssa')[0].scrollHeight) + 'px';


   },0)

    },

    cancelselrep(item,itm){

        var x=this.comments.map((itms)=>{
              if(itms.id==itm.id){

                  var newrep=itm.reply.map((itma)=>{
                    if(itma.id==item.id){
                      return{
                        ...itma,
                        selected:false,
                        editcontent:''
                      }
                    }else{
                          return itma
                    }
                  })
                  return {
                    ...itms,
                    reply:[
                    ...newrep]
                  }
              }else{
                return itms
              }
        })
 console.log('x')
 console.log(x)

        this.comments=[
        ...x
        ]


    },
    seteditreply(item,itm,index){
        
 
        var x=this.comments.map((itms)=>{
              if(itms.id==itm.id){

                  var newrep=itm.reply.map((itma)=>{
                    if(itma.id==item.id){
                      return{
                        ...itma,
                        selected:true,
                        editcontent:item.commenttext
                      }
                    }else{
                          return itma
                    }
                  })
                  return {
                    ...itms,
                    reply:[
                    ...newrep]
                  }
              }else{
                return itms
              }
        })
 console.log('x')
 console.log(x)

        this.comments=[
        ...x
        ]



   setTimeout(()=>{

console.log(document.getElementsByClassName('reptext')[index].scrollHeight+'----')
 
      document.getElementsByClassName('reptext')[index].style.height = 'auto';
document.getElementsByClassName('reptext')[index].style.height = (document.getElementsByClassName('reptext')[index].scrollHeight) + 'px';
   },10)

    },
    editcommentreply(item,itm){

        var x=itm.reply.map((its)=>{

          if(its.id==item.id){
            return{
              ...its,
              commenttext:item.editcontent,
              selectedreply:false,
              selected:false
            }
          }else{
            return its
          }
        })
      fb.db.collection("wlframeprojects").doc(this.$route.query.folder).collection('videos').doc(this.$route.query.id).collection('comments').doc(itm.ids).update({
       reply:[
       ...x
       ]
      })


    },
    editcomment(item){


      fb.db.collection("wlframeprojects").doc(this.$route.query.folder).collection('videos').doc(this.$route.query.id).collection('comments').doc(item.ids).update({
        editcontent:'',
        commenttext:item.editcontent
      })


    },
    deletecon(item){


          this.tempdata={
            ...item
          }
          this.deletebox=true
    },
    deleteconreply(item,itm){
 this.tempdata={
            ...itm
          }

          this.tempreply={
            ...item
          }

          this.deleteboxreply=true
    },
   deletes(){
    var vm=this
fb.db.collection("wlframeprojects").doc(this.$route.query.folder).collection('videos').doc(this.$route.query.id).collection('comments').doc(this.tempdata.ids).delete().then(()=>{
vm.deletebox=false
 
 fb.db.collection("wlframeprojects").doc(this.$route.query.folder).collection('videos').doc(this.$route.query.id).update({
  commentcount:Number(this.alldata.commentcount)-1
})


})
   },
   deletesreply(){
    var vm=this
    console.log(this.tempdata)
var x=this.tempdata.reply.filter((itm)=>{
  return itm.id!=this.tempreply.id
})

fb.db.collection("wlframeprojects").doc(this.$route.query.folder).collection('videos').doc(this.$route.query.id).collection('comments').doc(this.tempdata.ids).update({

  reply:[
  ...x
  ]
}).then(()=>{
vm.deleteboxreply=false

 fb.db.collection("wlframeprojects").doc(this.$route.query.folder).collection('videos').doc(this.$route.query.id).update({
  commentcount:Number(this.alldata.commentcount)-1
})





})
   },
   addcoment(){

 

 if(this.imagess==''){


  
    var x=this.comm
var vm=this
fb.db.collection("wlframeprojects").doc(this.$route.query.folder).collection('videos').doc(this.$route.query.id).update({
  commentcount:Number(this.alldata.commentcount)+1
})

fb.db.collection("wlframeprojects").doc(this.$route.query.folder).collection('videos').doc(this.$route.query.id).collection('comments').add({

commentby:{...vm.userinfo},
commenttext:vm.comm,
date:new Date().getDate()+':'+(new Date().getMonth()+1)+':'+new Date().getFullYear(),
time:new Date().getHours()+':'+new Date().getMinutes(),
status:false,
duration:vm.duration,
selected:false,
reply:[],
likes:0,
likedby:[],
selectedreply:false,
      replycontent:'',
      seconds:vm.timeseconds,
createdon:new Date(),
readby:0,
type:'main',
selected:false,
editcontent:'',
acttype:'normal',
id:Math.round(Math.random()*1000000000)

}).then(()=>{
 
 
var x=document.getElementsByTagName('input')
 
      
for(var i=0;i<x.length;i++){
  x[i].blur()
}

setTimeout(()=>{
 
   vm.comm=''
    document.getElementById('inch').style.height = 'auto';

  },100)
   const video = document.querySelector('video');
  if(vm.prevval){
   video.play()
      vm.prevval=false

   }


})


 }else{
 
   this.markerArea.startRenderAndClose();
 }

   },
    palyings(event){
      console.log(event)
    },
    downloads(){
  var urlCreator = window.URL || window.webkitURL;
 
    var imageUrl = this.alldata.video
    var tag = document.createElement('a');
    tag.href = imageUrl;
    tag.target = '_blank';
    tag.download = 'sample.mp4';
    document.body.appendChild(tag);
    tag.click();
    document.body.removeChild(tag);
    },
    getbyte(byte){
return Math.round(Number(byte.split(' ')[0]))+' '+byte.split(' ')[1]
    },
 setstatus(id){
  this.statusbox=false
  this.status=id
    
fb.db.collection("wlframeprojects").doc(this.$route.query.folder).collection('videos').doc(this.$route.query.id).update({
  status:id
}).then(()=>{

})
     

  }
 }
 

   
   
    
 
  
}
</script>
<style scoped >
 
</style>
 



// WEBPACK FOOTER //
// src/components/audioview.vue